import React from "react";
import Button from "@irati/ui/src/Button";
import FormattedMessage from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
var HomePageChangeView = function (props) {
    return (React.createElement(Flex, { id: "change-homepage-view", justifyContent: "flex-end", alignItems: "center" },
        React.createElement(Button, { primary: true, onClick: props.onChangePreview },
            React.createElement(FormattedMessage, { id: "platform.homepage.changeView.to.employeeView" }))));
};
export default HomePageChangeView;
